import React, { useEffect, useState } from "react";
import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/client";
import Sheet from "../Sheet/Sheet";

// Admin-only, metadata-only activity log for one resident's board. Never shows
// message text, photo names, or captions — only that something happened, by whom
// / on which screen, and when.
function describe(e) {
  if (e.category === "device") {
    if (e.action === "chimed") return { ic: "🔔", text: "Alarm chimed" };
    if (e.action === "ended") return { ic: "🔕", text: "Alarm stopped pulsing" };
    return { ic: "🔔", text: "Alarm event" };
  }
  const noun = e.type === "photo" ? "Photo" : e.type === "alarm" ? "Alarm" : "Message";
  const verb = e.action === "created" ? (e.type === "photo" ? "added" : e.type === "alarm" ? "set" : "posted")
    : e.action === "deleted" ? (e.type === "photo" ? "removed" : "deleted")
    : (e.type === "photo" ? "caption edited" : "edited");
  const ic = e.type === "photo" ? "🖼️" : e.type === "alarm" ? "⏰" : "📝";
  return { ic, text: `${noun} ${verb}` };
}

export default function EventLog({ open, onClose, residentId, tenantId, residentName }) {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    if (!open || !residentId || !tenantId) { setEvents([]); return undefined; }
    const q = query(
      collection(db, "boards", residentId, "events"),
      where("tenantId", "==", tenantId),
      orderBy("ts", "desc"),
      limit(200)
    );
    return onSnapshot(q,
      (snap) => setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      () => { /* non-fatal */ });
  }, [open, residentId, tenantId]);

  return (
    <Sheet open={open} onClose={onClose} title="Activity log"
      subtitle={residentName ? `for ${residentName}` : null}>
      {events.length === 0 && (
        <p className="sheet-note">No activity recorded yet.</p>
      )}
      <div className="evlog">
        {events.map((e) => {
          const { ic, text } = describe(e);
          const when = e.ts && e.ts.toDate ? e.ts.toDate() : null;
          const meta = e.category === "device"
            ? (e.pairingCode ? `screen ${e.pairingCode}` : "a screen")
            : (e.actorName || "");
          return (
            <div className="evlog-row" key={e.id}>
              <span className="evlog-ic" aria-hidden="true">{ic}</span>
              <div className="evlog-body">
                <div className="evlog-text">
                  {text}{meta ? <span className="evlog-meta"> · {meta}</span> : null}
                </div>
                <div className="evlog-when">{when ? when.toLocaleString() : ""}</div>
              </div>
            </div>
          );
        })}
      </div>
    </Sheet>
  );
}
